module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-nav-bar', {
    attrs: {
      "title": "在线客服",
      "left-arrow": ""
    },
    on: {
      "click-left": _vm.onClickLeft
    },
    scopedSlots: _vm._u([{
      key: "left",
      fn: function() {
        return [_c('van-icon', {
          attrs: {
            "name": "../../../static/images/mobile/back.png",
            "size": "18"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-tabbar', {
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('van-tabbar-item', {
    attrs: {
      "to": "/mobileHome"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.index.active : _vm.index.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("首页")])]), _vm._v(" "), _c('van-tabbar-item', {
    attrs: {
      "to": "/mobileStudy"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.classes.active : _vm.classes.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("班级")])]), _vm._v(" "), _c('van-tabbar-item', {
    attrs: {
      "to": "/mobileMy"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(props) {
        return [_c('img', {
          attrs: {
            "src": props.active ? _vm.my.active : _vm.my.inactive
          }
        })]
      }
    }])
  }, [_c('span', [_vm._v("我的")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-41ef01ae"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/MobileService.vue
// module id = 1146
// module chunks = 41